<template>
    <div>
        <b-tabs content-class="mt-3" pills>
            <template v-if="allowedBackground">
                <b-tab
                    v-for="(item, index) in backgrounds"
                    v-bind:key="'background-category-' + index"
                    :title="item.name"
                >
                    <ul class="item-list" id="background-select">
                        <li
                            v-for="(sItem, sIndex) in item.backgrounds"
                            v-bind:key="
                                'background-item-' + index + '-' + sIndex
                            "
                        >
                            <input
                                type="radio"
                                name="background"
                                :checked="
                                    !model.customFileBackground &&
                                        model.background === sItem.id
                                "
                                :id="'icon-background-' + index + '-' + sIndex"
                                v-on:change="selectBackground(sItem.id)"
                            />
                            <label
                                :for="'icon-background-' + index + '-' + sIndex"
                                class="d-block"
                                :title="sItem.name"
                                ><img :src="sItem.image" :alt="sItem.name" />
                            </label>
                        </li>
                    </ul>
                </b-tab>
            </template>
            <b-tab :title="$t('Színek')">
                <div class="creator-title">
                    {{ $t("Válassz háttér színt") }}:
                </div>

                <ul class="color-rounds" id="bgColorSwitcher">
                    <li
                        v-for="(item, index) in colors"
                        v-bind:key="'bg-color-' + index"
                    >
                        <input
                            type="radio"
                            name="background-color"
                            :id="'bg-color-' + item.id"
                            :checked="
                                !model.background &&
                                    !model.customFileBackground &&
                                    model.backgroundColor === item.hexa
                            "
                            v-on:change="selectColor(item.hexa)"
                        />
                        <label
                            :for="'bg-color-' + item.id"
                            class="d-block"
                            :title="item.name"
                            :aria-label="item.name"
                        >
                            <div
                                class="round"
                                :data-color="item.hexa"
                                :style="'background-color: ' + item.hexa"
                            ></div>
                        </label>
                    </li>
                </ul>
            </b-tab>
            <b-tab :title="$t('Egyedi háttér')" v-if="allowedBackground">
                <div class="creator-title">
                    {{ $t("Egyedi háttér feltöltése") }}:
                </div>
                <input
                    type="file"
                    ref="file"
                    name="custom-background"
                    class="d-none"
                    id="custom-icon-file-background"
                    v-on:change="handleFileUpload"
                    accept="image/png,image/jpeg,image/webp,image/gif"
                />
                <button
                    class="btn btn-simple upload"
                    v-on:click="$refs.file.click()"
                >
                    {{ $t("Fájl feltöltés") }}
                </button>
                <button
                    class="btn btn-link"
                    v-if="model.customFileBackground"
                    v-on:click="removeCustom"
                >
                    {{ $t("Egyedi háttér törlése") }}
                </button>
                <div class="text-danger small mt-2" v-if="error">
                    {{ error }}
                </div>
                <cropper
                    class="cropper mt-3"
                    v-if="source"
                    :src="source"
                    :stencilProps="{ aspectRatio: aspectRatio }"
                    @change="change"
                ></cropper>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { canvasToDataUrl, debounce } from "@/lib/sticker/image";

const MAX_UPLOAD_BYTES = 15 * 1024 * 1024;

export default {
    name: "TabBackground",
    props: [
        "model",
        "backgrounds",
        "colors",
        "allowedBackground",
        "aspectRatio"
    ],
    components: { Cropper },
    data() {
        return {
            source: null,
            error: null
        };
    },
    created() {
        this.change = debounce(({ canvas }) => {
            const image = canvasToDataUrl(canvas, {
                maxSize: 1600,
                type: "image/jpeg",
                quality: 0.9
            });
            if (image) {
                this.$emit("update", {
                    customFileBackground: image,
                    background: null
                });
            }
        }, 200);
    },
    beforeDestroy() {
        this.change.cancel();
        this.releaseSource();
    },
    methods: {
        selectBackground(id) {
            this.clearCustom();
            this.$emit("update", {
                background: id,
                customFileBackground: null
            });
        },
        selectColor(hexa) {
            this.clearCustom();
            this.$emit("update", {
                backgroundColor: hexa,
                background: null,
                customFileBackground: null
            });
        },
        removeCustom() {
            this.clearCustom();
            this.$emit("update", { customFileBackground: null });
        },
        clearCustom() {
            this.change.cancel();
            this.releaseSource();
            if (this.$refs.file) {
                this.$refs.file.value = "";
            }
        },
        releaseSource() {
            if (this.source) {
                URL.revokeObjectURL(this.source);
                this.source = null;
            }
        },
        handleFileUpload() {
            const file = this.$refs.file.files[0];
            this.error = null;
            if (!file) {
                return;
            }
            if (!file.type.startsWith("image/")) {
                this.error = this.$translate.t("Csak képfájl tölthető fel.");
                return;
            }
            if (file.size > MAX_UPLOAD_BYTES) {
                this.error = this.$translate.t(
                    "A fájl túl nagy (legfeljebb 15 MB)."
                );
                return;
            }
            this.releaseSource();
            this.source = URL.createObjectURL(file);
        }
    }
};
</script>

<style scoped></style>
